import type { ClipboardEvent } from 'react';

/**
 * Plain-text paste handler shared by the title and description
 * contentEditable nodes across all report pages. Strips any HTML /
 * styled fragments off the clipboard so they can't leak into the DOM
 * (and round-trip into the stored title/description).
 * `document.execCommand('insertText')` is formally deprecated but
 * remains the only cross-browser way to splice text into a
 * contentEditable at the current selection without reimplementing
 * range/selection plumbing — every evergreen browser still implements it.
 */
export function handlePlainTextPaste(e: ClipboardEvent<HTMLElement>): void {
  e.preventDefault();
  const text = e.clipboardData.getData('text/plain');
  document.execCommand('insertText', false, text);
}
